import request from '../../../shared/request'

export function getLeadContract(lead_id) {
  return request(`/lead/contracts/${lead_id}/`)
}

export function createLeadContract(payload) {
  return request(`/lead/contracts/${payload.lead_id}/`, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function updateLeadContract(payload) {
  return request(`/lead/contracts/${payload.contract_id}/`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteLeadContract(payload) {
  return request(`/lead/contracts/${payload.contract_id}/?leadId=${payload.leadId}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

// ATTACHMENTS
export function uploadAttachments(payload) {
  return request(`/lead/contracts/${payload.contractId}/attachment`, {
    method: 'POST',
    body: payload.formData,
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}

export function getAttachments(contractId) {
  return request(`/lead/contracts/${contractId}/attachments/`)
}

export function updateAttachmentDescription(payload) {
  return request(`/lead/contracts/${payload.attachmentId}/attachment`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteAttachment(payload) {
  return request(`/lead/contracts/${payload.attachmentId}/attachment/`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function setLeadContractStatus(payload) {
  return request(`/lead/contracts/${payload.contract_id}/status`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}



// WEBPACK FOOTER //
// ./src/redux/api/lead/contracts.js